import * as types from "../actions/types";

const initialState = {
  programs: [],
  terms: [],
};

export default function program(state = initialState, action) {
  switch (action.type) {
    case types.PROGRAM_FETCH_COMPLETED:
      return {
        ...state,
        programs: action.programs,
      };
    case types.NEW_TERMS_FETCH_COMPLETED:
      return {
        ...state,
        terms: action.terms.terms,
      };
    default:
      return state;
  }
}
